<template lang="pug">
  .container.grid-xl
    page-title(title="Balanços" icon="fas fa-balance-scale-right" subtitle="Balanços dos afiliados")
      div(slot="actions")
        actions.mr-2
        //- router-link.btn.btn-link.tooltip.tooltip-left.mr-2(
        //-   :to="{ name: 'filiations.balances.list.filter', query: $route.query }"
        //-   data-tooltip="Filtrar"
        //- )
        //-   i.fas.fa-filter
        //-   span.badge(v-if="Boolean($route.query.q)")
    list-manager(:loading="loading" :error="error" :paginated-list="list" @fetch-data="fetchData")
      table.table(v-if="list")
        thead
          tr
            th Mês
            th Afiliado
            th Status
            th Última atualização
            th.text-right Assinaturas
            th.text-right Compras
            th.text-right Conteúdo
            th.text-right Total
            th(width="60")
        tbody
          row(v-for="balance in list.rows" :balance="balance" :key="balance.id" @updated="onUpdate")
    router-view(:fetch-data="fetchData")
</template>

<script>
import filiationBalances from '@/services/filiationBalances'
import Actions from './components/ListActions'
import Row from './components/Row'

export default {
  data() {
    return {
      list: null,
      loading: false,
      error: null,
    }
  },
  components: { Actions, Row },
  methods: {
    async fetchData(params = {}) {
      try {
        this.loading = true
        const { data } = await filiationBalances.list({
          ...params,
          q: { ...(params.q || {}) },
        })
        this.list = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
    onUpdate(balance) {
      this.list.rows = this.list.rows.map(row =>
        row.id === balance.id ? balance : row,
      )
    },
  },
  created() {
    const params = this.$route.query
    this.fetchData(params)
  },
}
</script>
